export interface IPacingTypeOption {
  text: string;
  value: number;
}

export const pacingTypeOptions: IPacingTypeOption[] = [
  {
    text: 'Evenly',
    value: 1,
  },
  {
    text: 'Frontloaded',
    value: 2,
  },
  {
    text: 'ASAP',
    value: 3,
  },
];

export const orderPacingTypeOptions: IPacingTypeOption[] = pacingTypeOptions.concat([
  {
    text: 'None',
    value: 4,
  },
]);

export const getPacingTypeOption = (value: number): IPacingTypeOption | undefined => {
  return pacingTypeOptions.find((opt) => {
    return opt.value === Number(value);
  });
};

export const getPacingTypeOptionByText = (text: string): IPacingTypeOption | undefined => {
  return pacingTypeOptions.find((opt) => {
    return opt.text === text;
  });
};

export const getOrderPacingTypeOption = (value: number): IPacingTypeOption | undefined => {
  return orderPacingTypeOptions.find((opt) => {
    return opt.value === Number(value);
  });
};

export const getOrderPacingTypeOptionByText = (text: string): IPacingTypeOption | undefined => {
  return orderPacingTypeOptions.find((opt) => {
    return opt.text === text;
  });
};
